<template>
  <div class="c_title">
    <span class="t_es">{{ titleEn }} </span>
    <span class="t_zh">{{ titleZh }}</span>
  </div>
</template>

<script>
export default {
  props: ["titleEn", "titleZh"],
};
</script>

<style lang="scss" scoped>
$themeColor: #003b99;
.c_title {
  height: 44px;
  padding: 40px 0 0 0;
  position: relative;
  .t_es {
    font-size: 36px;
    font-weight: bold;
    color: #444444;
    opacity: 0.1;
  }
  .t_zh {
    font-size: 24px;
    line-height: 24px;
    font-weight: bold;
    color: $themeColor;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}
</style>
